import React, { Component, Fragment } from 'react';
import { services } from '@comall-backend-builder/core';
import { Button as AntButton, Table, Input, Tag, Spin } from 'antd';
import { errorHandle } from '../../services/error-handle';
import { SkuModal } from './components/SkuModal';

interface ChangePriceSelectorProps {
    componentId: string;
}

interface ChangePriceSelectorStates {
    columns: object[];
    options: object[];
    tableData: object[];
    orderId: string;
    loading: boolean;
    spinning: boolean;
    listVisible: boolean;
    record: any;
}

export class ChangeSku extends Component<ChangePriceSelectorProps, ChangePriceSelectorStates> {
    constructor(props: ChangePriceSelectorProps) {
        super(props);
        this.state = {
            spinning: false,
            orderId: '',
            columns: [
                {
                    title: 'orderNo',
                    dataIndex: 'orderNo',
                    key: 'orderNo',
                },
                {
                    title: 'SKN',
                    dataIndex: 'sknCode',
                    key: 'sknCode',
                },
                {
                    title: 'SKU',
                    dataIndex: 'skuCode',
                    key: 'skuCode',
                },
                {
                    title: 'productName',
                    dataIndex: 'productName',
                    key: 'productName',
                },
                {
                    title: '置换',
                    key: 'changeSku',
                    dataIndex: 'changeSku',
                    render: (_: any, record: any) => (
                        <Tag onClick={() => this.showModal(record)}>置换</Tag>
                    ),
                },
            ],
            options: [],
            tableData: [],
            loading: false,
            listVisible: false,
            record: {},
        };
        this.loadSknList = this.loadSknList.bind(this);
        this.saveSknChangePrice = this.saveSknChangePrice.bind(this);
    }
    showModal(r: any) {
        const { listVisible } = this.state;
        this.setState({
            listVisible: !listVisible,
            record: r,
        });
    }
    loadSknList() {
        this.setState({
            loading: true,
        });
        services.api
            .get({}, { apiPath: `/orderReplaceSkn/get_order_item/${this.state.orderId}` })
            .then((res: any) => {
                const result = res || [];
                this.setState({
                    tableData: result,
                    loading: false,
                });
            })
            .catch((e: any) => {
                errorHandle(e);
            });
    }
    saveSknChangePrice() {}

    render() {
        const { spinning, listVisible, orderId, record } = this.state;
        return (
            <Fragment>
                <Spin spinning={spinning}>
                    <span>选择销售订单：</span>
                    <Input
                        style={{ width: 300, marginBottom: '10px' }}
                        placeholder="请输入销售订单"
                        onChange={(v) => {
                            this.setState({
                                orderId: v.target.value,
                            });
                        }}
                    />
                    <AntButton style={{ marginLeft: 16 }} type="primary" onClick={this.loadSknList}>
                        查询
                    </AntButton>
                    <Table
                        rowKey="sknCode"
                        loading={this.state.loading}
                        pagination={false}
                        columns={this.state.columns}
                        dataSource={this.state.tableData}
                    />
                </Spin>
                {listVisible && (
                    <SkuModal
                        orderId={orderId}
                        visible={listVisible}
                        record={record}
                        onCancel={() => {
                            this.setState({
                                listVisible: false,
                            });
                            this.loadSknList();
                        }}
                    />
                )}
            </Fragment>
        );
    }
}
